var BowUse = {
    handle: "bow_use",
    
    abilities: {
        arrow_shot: {
            handle: "arrow_shot",
            unlockLevel: 1 
        },

        range: {
            handle: "range",
            unlockLevel: 6,
            passive: true
        },
        
        leg_shot: {
            handle: "leg_shot",
            unlockLevel: 14 
        },

        razor_shot: {
            handle: "razor_shot",
            unlockLevel: 22
        },
        
        blunt_arrow: {
            handle: "blunt_arrow",
            unlockLevel: 30 
        },

        chain_pull: {
            handle: "chain_pull",
            unlockLevel: 38 
        },    

        multi_shot: {
            handle: "multi_shot",
            unlockLevel: 46 
        }  
    }
};
module.exports = BowUse;